export const POST_MENU_COPY_LINK = 'post-menu.copy-link';
export const POST_MENU_HIDE_POST = 'post-menu.hide-post';
export const POST_MENU_EDIT = 'post-menu.edit';
export const POST_MENU_DELETE = 'post-menu.delete';
export const POST_MENU_DELETION_DIALOG_MESSAGE = 'post-menu.deletion-dialog-message';
